import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import ListPromotionRow from '@/features/buybox/components/list/ListPromotionRow.vue';
import { computed, ref } from 'vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import FreeTrialSwiperOSContainer from '@/features/buybox/components/grid/FreeTrialSwiperOSContainer.vue';
import { usePromotion, UsePromotion } from '@/helpers/composables/usePromotion';
import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { PPSwiperRule, usePPSwiperExp } from '@/components/experiments/PPExperiments/PPSwiperExp';
import SingleQTV from '@/features/buybox/components/list/SingleQTV.vue';
import QualityTV from '@/features/buybox/components/list/QualityTV.vue';
import { observableOptions } from '@/helpers/composables/useOfferImpressionTracking';

interface ClickoutPayload {
	buyboxOffer: UsePromotion['promotionOffer'];
	offerLocation: OfferLocation.FREE_TRIAL;
	row: HTMLElement | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PPExpSwiper',
  props: {
    offers: null,
    title: null,
    additionalContexts: { default: () => [] },
    episodeNumber: null,
    seasonNumber: null
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as { offers: Offer[], title: TitleDetail, additionalContexts: SnowplowContext[], episodeNumber?: number | null, seasonNumber?: number | null };





const { catalogueItem } = usePromotion({
	title: () => props.title,
	offers: () => props.offers,
});

const { getPPSwiperConfig } = usePPSwiperExp();

const swiperConfig = computed(() => {
	return getPPSwiperConfig() ?? null;
});

const swiperPackages = computed<PPSwiperRule['packages']>(() => swiperConfig.value?.packages ?? []);

const swipeIndex = ref(0);

const isShowOrSeason = computed(() => ['Show', 'Season'].includes(props.title.__typename));

const slideDelay = computed(() => (swiperConfig.value?.slideDelay ?? 1500) - observableOptions.throttle);

const slideToPackageId = computed(() => swiperConfig.value?.default.id ?? null);

const swiperSlideToIndex = computed(() => {
	if (swiperPackages.value == null || slideToPackageId.value == null) return 0;

	return Math.max(
		0,
		swiperPackages.value.findIndex(el => el.id === slideToPackageId.value)
	);
});

function slideChange({
	direction,
	position,
	nonInteraction,
}: {
	direction: string;
	position: number;
	nonInteraction: boolean;
}) {
	const parsedInitialPosition = Number(swipeIndex.value);
	const initialPosition = isNaN(parsedInitialPosition) ? undefined : parsedInitialPosition;

	const category = nonInteraction ? 'automation' : 'userinteraction';
	const action = nonInteraction ? 'auto_swipe' : 'swipe_clicked';

	swipeIndex.value = position;

	TrackingHelper.trackEvent(category, {
		action,
		label: direction,
		nonInteraction,
		value: initialPosition,
		property: 'geo_swiper',
	});
}

return { __sfc: true,props, catalogueItem, getPPSwiperConfig, swiperConfig, swiperPackages, swipeIndex, isShowOrSeason, slideDelay, slideToPackageId, swiperSlideToIndex, slideChange, ListPromotionRow, FreeTrialSwiperOSContainer, SingleQTV, QualityTV }
}

})